import { render, staticRenderFns } from "./AsyncComponentLoad.vue?vue&type=template&id=21311a6e"
import script from "./AsyncComponentLoad.vue?vue&type=script&lang=js"
export * from "./AsyncComponentLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports